import React from 'react';
import { Button } from 'antd';
import cx from 'classnames';
import { connect } from 'react-redux';

import { Features, isFeatureEnabled } from '../../../../featureToggles/features';
import { contactSales } from '../../../../slices/settings/subscription.thunk';
import { AccessTypes } from '../../../common/domain/accountAccessType';
import { plansInfo } from './constants';
import { ProTrialConfirmationModal } from './ProTrialConfirmationModal';
import { ProTrialButton } from './proTrialButton';

import styles from './otherPlans.module.scss';

interface OtherPlansPropsLite {
  actualPlan: AccessTypes.Lite;
  isAdmin?: boolean;
  onUpgradeToPro: () => void;
}

interface OtherPlansPropsPro {
  actualPlan: AccessTypes.Professional;
  isAdmin?: boolean;
}

interface DispatchProps {
  contactSales: () => void;
}

interface OtherPLansState {
  showConfirmationModal: boolean;
}

type OtherPlansProps = OtherPlansPropsLite | OtherPlansPropsPro;

type Props = OtherPlansProps & DispatchProps

class OtherPlansBase extends React.Component<Props, OtherPLansState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showConfirmationModal: false
    };
    this.handleDisplayConfirmationModal = this.handleDisplayConfirmationModal.bind(this);
  }

  private handleDisplayConfirmationModal() {
    this.setState((state) => ({ showConfirmationModal: !state.showConfirmationModal }));
  }

  private renderPlan(plan: AccessTypes.Professional | AccessTypes.Enterprise) {
    const { actualPlan } = this.props;
    const planInfo = plansInfo[plan];
    const isProPlan = plan === AccessTypes.Professional;
    const onClick = actualPlan === AccessTypes.Lite && isProPlan ? this.props.onUpgradeToPro : this.props.contactSales;

    return <div key={plan} className={cx(styles.plan, { [styles.pro]: plan === AccessTypes.Professional })}>
      <div className={styles.name}>{planInfo.name}</div>
      <div className={styles.users}>{planInfo.users}</div>
      <div className={styles.description}>{planInfo.description}</div>
      <ul className={styles.customList}>
        {planInfo.features.map((feature, index) =>
          <li key={index}>{feature}</li>
        )}
      </ul>
      <Button type="primary" onClick={onClick}>
        {planInfo.upgradeText}
      </Button>
      {
        isProPlan && isFeatureEnabled(Features.TrialsOfTiers) &&
        <ProTrialButton className={styles.trial} onClick={this.handleDisplayConfirmationModal} />
      }
    </div>;
  }

  private renderPlans() {
    const { actualPlan, isAdmin } = this.props;
    const plansToRender: (AccessTypes.Professional | AccessTypes.Enterprise)[] =
      actualPlan === AccessTypes.Lite ? [AccessTypes.Professional, AccessTypes.Enterprise] : [AccessTypes.Enterprise];
    return <div className={cx(styles.plansContainer, { [styles.single]: plansToRender.length === 1, [styles.isAdmin]: isAdmin })} >
      {plansToRender.map(plan => this.renderPlan(plan))}
    </div >;
  }

  render(): JSX.Element {
    const { showConfirmationModal } = this.state;
    return (
      <>
        <div className={styles.container}>
          <span className={styles.badge}>Other Plans</span>
          {this.renderPlans()}
          <a href="/settings/subscription/compare">
            <Button type="default">Compare all plans</Button>
          </a>
        </div>
        {
          showConfirmationModal &&
          <ProTrialConfirmationModal onClose={this.handleDisplayConfirmationModal}/>
        }
      </>
    );
  }
}

export const OtherPlans = connect<void, DispatchProps, OtherPlansProps>(null, { contactSales })(OtherPlansBase);